import { StopConnection } from '@/new-transport/_models/transport-timetable.model';

export const findStopConnection = (
	stopsConnections: StopConnection[],
	currentStopId: number,
	nextStopId: number,
): StopConnection =>
	stopsConnections.find(
		(connection) => connection.transportStopFrom === currentStopId && connection.transportStopTo === nextStopId,
	);
